import axiosInstance from "./axiosInstance";

export const getAllClientEnquiry = async () => {
    try {
        const response = await axiosInstance.get("/ClientEnquiry", {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch Client Enquiry");
    }
};

export const getClientEnquiryById = async (id) => {
    try {
        const response = await axiosInstance.get(`/ClientEnquiry/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to fetch Client Enquiry");
    }
};

export const createClientEnquiry = async (formData) => {
    try {
        const response = await axiosInstance.post("/public/ClientEnquiry", formData, {
            headers: {
                "Content-Type": "application/json",
                authType: "PreLogin",
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to create Client Enquiry");
    }
};

export const deleteClientEnquiry = async (id) => {
    try {
        const response = await axiosInstance.delete(`/ClientEnquirydel/${id}`, {
            headers: { authType: "PostLogin" },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.token || "Failed to delete Client Enquiry");
    }
};